import logo from '../../assets/mileboard-logo.svg';
import styles from './Logo.module.css';

const Logo = () => <img className={styles.logo} alt="mileboard-logo" src={logo} />;

export default Logo;
